// Things related to the issues page
const Issues = {
    messageIds: {
        main: 'issuesMessage1',
        details: 'issuesMessage2'
    },
    currentIssueData: null,
    currentIssueEntry: null,
    // Show details for a specific issue
    showIssueDetails: async (entryData)=>{
        Issues.panelManager.showDetailsPanel();
        Issues.setStaticText(true);
        const issueDetailsTitle = CP.getel('issueDetailsTitle');
        const issueDateDiv = CP.getel('issueDate');
        const issueContentDiv = CP.getel('issueContent');
        const copyUrlButton = CP.getel('copyIssueUrlButton');
        const csvButton = CP.getel('downloadCsvButton');
        const bcfButton = CP.getel('downloadBcfButton');
        // Reset action buttons and stored data at the start of every open so
        // stale state from a previous issue can't survive a navigation or a
        // failed load.
        CP.hideEl(copyUrlButton);
        CP.hideEl(csvButton);
        CP.hideEl(bcfButton);
        Issues.currentIssueData = null;
        Issues.currentIssueEntry = null;
        // Reset any previous italic styling before setting the title text.
        issueDetailsTitle.classList.remove('italic');
        if (entryData.entryValue.File?.Filename != null) issueDetailsTitle.textContent = Util.getFilenameWithoutExtension(entryData.entryValue.File.Filename);
        else {
            issueDetailsTitle.textContent = 'Unnamed Issue';
            issueDetailsTitle.classList.add('italic');
        }
        issueDateDiv.textContent = CP.getCreatedDateForUI({
            entryData: entryData
        });
        // Set up the click handler for the copy URL button
        copyUrlButton.onclick = async ()=>{
            CP.notify("Creating shareable link...", true);
            const result = await CP.createShareGroupWithEntry(entryData, "Issue");
            if (result.success) {
                const shareUrl = `${CP.getSiteBaseUrl()}/sharedissues.html?sharegroupid=${CP.getBytesAsURIComponent(result.shareGroupID)}`;
                await CP.copyToClipboard(shareUrl);
                CP.notify("Shareable URL copied to clipboard.", false);
            }
        };
        CP.notify("Loading issue details...", true);
        const groupInfo = await CP.retrieveEncryptionKeyAndCheckVersion();
        const displayResult = await IssueDisplayer.fetchAndDisplayIssues(groupInfo, issueContentDiv, entryData, CP.showErrorMessage);
        CP.hideNotification();
        if (displayResult.success) {
            // Store issue data for export functionality
            Issues.currentIssueData = displayResult.issueData;
            Issues.currentIssueEntry = entryData;
            CP.showEl(copyUrlButton);
            CP.showEl(csvButton);
            CP.showEl(bcfButton);
            // Wire export buttons via the centralized helper
            ExportUtil.wireDownloadButtons(csvButton, bcfButton, ()=>Issues.currentIssueData, ()=>Issues.currentIssueEntry);
            // Wire image viewer using delegated listener
            try {
                if (window.IssueImageViewer) IssueImageViewer.wireDelegated(issueContentDiv);
            } catch (err) {
                console.error('Failed to initialize image viewer:', err);
            }
        }
    }
};
Issues.fillTable = CP.createStandardFillTable(Issues, 'IssuesTableBody', (entry)=>entry.entryValue.File?.ArkioIssues != null, (entryData)=>Issues.showIssueDetails(entryData));
CP.setupPageWithPanels(Issues, {
    mainPanelId: 'mainIssuesDiv',
    detailsPanelId: 'issueDetailsDiv',
    backArrowId: 'issuesPanelBackArrow',
    fillTable: Issues.fillTable,
    messageAreasContainerId: 'messageAreas'
});

//# sourceMappingURL=repo.099f7fa3.js.map
